
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teams/new",
      function () {
        return require("private-next-pages/teams/new.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teams/new"])
      });
    }
  